import { render, staticRenderFns } from "./voucherCreateScm8.vue?vue&type=template&id=5318198f&scoped=true&"
import script from "./voucherCreateScm8.vue?vue&type=script&lang=js&"
export * from "./voucherCreateScm8.vue?vue&type=script&lang=js&"
import style0 from "./voucherCreateScm8.vue?vue&type=style&index=0&id=5318198f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5318198f",
  null
  
)

export default component.exports